import React from 'react'
import Head from 'next/head'

import { Header } from 'app/AccountDeletionPage/components/Header'
import AccountDeletionApp from 'app/AccountDeletionPage'

export const AccountPage = () => {
  return (
    <div className="min-h-fit">
      <Head>
        <title>Pengajuan Hapus Akun - Ruang GTK</title>
      </Head>
      <AccountDeletionApp />
    </div>
  )
}

AccountPage.layoutOpts = {
  hasHeader: true,
  header: Header,
}

export default AccountPage
